export default __webpack_public_path__ + "static/media/CNo.47-0.0863bcf2.jpg";